import React, { useCallback } from 'react';
import "./signoutModal.css"
import { signout } from '../../api/apiHandler';
import { useDispatch } from 'react-redux';
import { logout } from '../../slices/authSlice';
import { removeCartData } from '../../slices/cartPaymentSlice';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../../i18'; 

const SignoutModal = ({ isOpen, onClose }) => {
    const { t } = useTranslation();

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleSignout = useCallback(
        async () => {
            signout()
                .then((response) => {
                    if (response.code == 200) {
                        dispatch(logout());
                        dispatch(removeCartData());
                        localStorage.removeItem("language");
                        navigate("/");
                    }
                });
                onClose()
        }
    )

    if (!isOpen) return null;
    return (
        <>
            <div className="LogOutOverlay">
                <div
                    id="LogOutModal"
                    tabIndex={-1}
                    aria-hidden="true"
                    className="modal-dialog modal-dialog-centered"
                >
                    <div className="modal-content">
                        <div className="modal-header">
                            <h6 className="modal-title">{t('signOut')}</h6>
                            <button
                                type="button"
                                className="btn-close"
                                onClick={onClose}
                                aria-label="Close"
                            />
                        </div>
                        <div className="modal-body">
                            <p className="DeleteModaltext">{t('confirmSignOut')}</p>
                        </div>
                        <div className="modal-footer d-flex justify-content-center gap-4 border-0">
                            <button className="ModalYesLink" onClick={handleSignout}> {t('yes')} </button>
                            <button
                                className="ModalNoLink"
                                onClick={onClose}
                            >
                                {t('no')}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SignoutModal;